import '../assets/stylesheets/home.css';
import amazonIcon from '../assets/icons/amazon.png';
import bookReviewImage from '../assets/images/bookreview.jpeg';
import leftQuokkaImage from '../assets/images/left quokka.png';
import rightQuokkaImage from '../assets/images/right quokka.png';
import coverQuokkaImage from '../assets/images/coverquokka.png';
import quokkaPageTwoImage from '../assets/images/quokka page two.PNG';
import quokkaPageThreeImage from '../assets/images/quokka page three.png';
import quokkaPageOneImage from '../assets/images/quokka page one.png';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import {Link} from 'react-router-dom';

// Import your audio files
import audioSlide1 from '../assets/audio/cover.mp3';
import audioSlide2 from '../assets/audio/smile_when_sleeping.mp3';
import audioSlide3 from '../assets/audio/smile_when_awake.mp3';
import audioSlide4 from '../assets/audio/smile_to_greet_you.mp3';

const countDownDate = new Date("Apr 14, 2025 00:00:00").getTime();

export default function Home() {
    const [durationState, setDurationState] = useState(0);
    const carouselRef = useRef(null);
    const audioRefs = useRef([]); // Ref to store audio elements

    useEffect(() => {
        const intervalId = setInterval(() => {
            const now = new Date().getTime();
            const duration = countDownDate - now;

            if (duration < 0) {
                clearInterval(intervalId);
                setDurationState(0);
                return;
            }

            setDurationState(duration);
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const colouredIntervalId = setInterval(() => {
            if (carouselRef.current) {
                const slideimages = carouselRef.current.querySelectorAll('div.carousel-item');
                slideimages.forEach(item => {
                    const imgElement = item.children[0];
                    if (item.classList.contains('active')) {
                        imgElement.classList.remove('gray');
                        imgElement.classList.add('coloured');
                    } else {
                        imgElement.classList.remove('coloured');
                        imgElement.classList.add('gray');
                    }
                });
            }
        }, 0);

        return () => clearInterval(colouredIntervalId);
    }, []);

    // Function to stop all audio elements (memoized)
    const stopAllAudio = useCallback(() => {
        audioRefs.current.forEach(audio => {
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
        });
    }, [audioRefs]);

    // Function to handle slide changes and play audio (memoized)
    const handleSlideChange = useCallback(() => {
        if (carouselRef.current) {
            const activeIndex = Array.from(carouselRef.current.querySelectorAll('.carousel-item')).findIndex(item =>
                item.classList.contains('active')
            );
            stopAllAudio(); // Stop any currently playing audio
            if (audioRefs.current[activeIndex]) {
                audioRefs.current[activeIndex].play();
            }
        }
    }, [stopAllAudio, audioRefs]);

    useEffect(() => {
        const carouselElement = carouselRef.current;
        if (carouselElement) {
            const handleSlideEvent = () => {
                console.log("Carousel slid event triggered");
                handleSlideChange();
            };

            // Attach the 'slid.bs.carousel' event listener
            carouselElement.addEventListener('slid.bs.carousel', handleSlideEvent);

            // Clean up the event listener when the component unmounts
            return () => {
                carouselElement.removeEventListener('slid.bs.carousel', handleSlideEvent);
            };
        }
    }, [handleSlideChange]); // Dependency array now includes handleSlideChange

    const daysVal = Math.floor(durationState / (1000 * 60 * 60 * 24));
    const hrsVal = Math.floor((durationState % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minsVal = Math.floor((durationState % (1000 * 60 * 60)) / (1000 * 60));
    const secsVal = Math.floor((durationState % (1000 * 60)) / 1000);

    return (
        <main>
            <section id="premiere">
                <section id="premierecontent">
                    <h1 id="premieretitle">
                        Latest Release
                    </h1>
                    <h2 id="premieresubtitle">THE SmILING QUOKKA</h2>
                    <h3>AVAILABLE IN</h3>
                    <div className="ctdwncont">
                        <div className="valcont"><span className='spanval' id="counterdays">{daysVal}</span> <span className='spanlabel'> DAYS</span></div>
                        <div className="valcont"><span className='spanval' id="counterhrs">{hrsVal}</span> <span className='spanlabel'> HRS</span></div>
                        <div className="valcont"><span className='spanval' id="countermins">{minsVal}</span> <span className='spanlabel'> MINS</span></div>
                        <div className="valcont"><span className='spanval' id="countersecs">{secsVal}</span> <span className='spanlabel'> SECS</span></div>
                    </div>
                    <Link to='https://www.amazon.com/dp/B0F1MCRYHJ?ref_=pe_93986420_775043100' target="_blank" rel="noopener" className="orderbtn"> <span>Order Now</span> <img src={amazonIcon} alt="buy the talking quokka book by abigail gordon" id="buyicon" /> </Link>
                </section>
                <section className="premiereimg"><img id="quokka" alt="the smiling quokka available on amazon" src={bookReviewImage} /> </section>
            </section>

            <section id="preview">
                <h1>TAKE A PEEK</h1>
                <section id="previewcontent">
                    <div className="slidebordercont"><img src={leftQuokkaImage} alt="buy the talking quokka book by abigail gordon" className="slideborderimg" /> </div>
                    <div
                        id="bookcarousel"
                        className="carousel slide "
                        data-ride="carousel"
                        data-interval="7000"
                        ref={carouselRef}
                    >
                        <ol className="carousel-indicators">
                            <li data-target="#bookcarousel" data-slide-to="0" className="active"></li>
                            <li data-target="#bookcarousel" data-slide-to="1"></li>
                            <li data-target="#bookcarousel" data-slide-to="2"></li>
                            <li data-target="#bookcarousel" data-slide-to="3"></li>
                        </ol>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img className="d-block  slideimg" src={coverQuokkaImage} alt="The Smiling Quokka First slide" />
                                <audio ref={el => (audioRefs.current[0] = el)} src={audioSlide1} />
                            </div>
                            <div className="carousel-item">
                                <img className="d-block  slideimg" src={quokkaPageTwoImage} alt="The Smiling Quokka Second slide" />
                                <audio ref={el => (audioRefs.current[1] = el)} src={audioSlide2} />
                            </div>
                            <div className="carousel-item">
                                <img className="d-block  slideimg" src={quokkaPageThreeImage} alt="The Smiling Quokka Third slide" />
                                <audio ref={el => (audioRefs.current[2] = el)} src={audioSlide3} />
                            </div>
                            <div className="carousel-item">
                                <img className="d-block  slideimg" src={quokkaPageOneImage} alt="The Smiling Quokka Fourth slide" />
                                <audio ref={el => (audioRefs.current[3] = el)} src={audioSlide4} />
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#bookcarousel" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#bookcarousel" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
                    <div className="slidebordercont"><img src={rightQuokkaImage} alt="buy the talking quokka book by abigail gordon" className="slideborderimg" /> </div>
                </section>
            </section>
        </main>
    );
}